// extracted by mini-css-extract-plugin
export default {"base":"base--VLgHf","article":"article--VLgHf","aside":"aside--VLgHf","inner":"inner--VLgHf"};